 export enum DebtorsStatusEnum {
    STATUS = 'ACTIVE',
    STATUS_SPN = 'Activos',
    ACTIVEVALUE = '1',
    INACTIVEVALUE = '2',
    ACTIVETEXT ='ACTIVE',
    INACTIVETEXT = 'INACTIVE'
  }

  
